import axios from "axios";

const mail = {
  methods: {
    mail(to, subject, body) {
      axios({
        method: "post",
        url: "https://mailing-advg.herokuapp.com/sendMail",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        },
        data: {
          email: to,
          subject: subject,
          body: body
        }
      }).then(res => {
        console.log(res)
      }).catch(e => {
        console.log(e);
      });
    }
  }
};
export default mail;
